import isomorphicFetch from 'isomorphic-fetch';
import { Store } from 'omni-common-ui';

function downloadFile(filename, blob) {
  if (navigator.appVersion.toString().indexOf('.NET') > 0 ||
      navigator.appVersion.toString().indexOf('Edge') > 0) {
    window.navigator.msSaveBlob(blob, filename);
  } else {
    const link = document.createElement('a');
    link.setAttribute('href', window.URL.createObjectURL(blob));
    link.setAttribute('download', filename);
    link.style.display = 'none';
    document.body.appendChild(link);
    link.click();
  }
  return Promise.resolve(filename);
}

function getBlob(response) {
  return response.blob();
}

function getTokenHeader(acceptType) {
  const user = Store.get().getState().get('singleSignOn').get('user') || {};
  const token = user.get('access_token');
  const headers = {
    Accept: acceptType,
    Authorization: `Bearer ${token}`,
    'Content-Type': 'application/json',
  };
  return headers;
}

const fetchWithBlob = (url, options = {}, acceptType) => {
  const _options = Object.assign(options);
  _options.headers = options.headers || {};
  Object.assign(_options.headers, getTokenHeader(acceptType));
  return isomorphicFetch(url, _options);
};

export const exporter = {
  get: (url, filename, body, acceptType) => {
    const method = body ? 'post' : 'get';
    const bodyString = body ? JSON.stringify(body) : undefined;
    const options = {
      method,
      body: bodyString,
    };

    return fetchWithBlob(url, options, acceptType)
      .then(checkResponseStatus)
      .then(getBlob)
      .then(downloadFile.bind(this, filename));
  },
};

function checkResponseStatus(response) {
  if (response.status >= 200 && response.status < 300) {
    return response;
  }

  const error = new Error(response.statusText);
  error.response = response;
  throw error;
}

export default exporter;



// WEBPACK FOOTER //
// ./domain/Exporter/index.js